import { render, staticRenderFns } from "./QTable.vue?vue&type=template&id=3f10cc08&scoped=true&"
import script from "./QTable.vue?vue&type=script&lang=js&"
export * from "./QTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f10cc08",
  null
  
)

export default component.exports